$(function() {
    $("#Frm_Recordar").submit(function(e) {
        e.preventDefault();
        var str = $("#Frm_Recordar").serialize();
        $.ajax({
            beforeSend: function() {
                $("#BT_Recordar_Pass").text("Enviando...");
                $("#BT_Recordar_Pass").attr("disabled", "true");
            },
            cache: false,
            type: "POST",
            dataType: "json",
            url: _rutaAJAX + 'recordarPass',
            data: str + "&BT_Editar=true&id=" + Math.random(),
            success: function(response) {
                if (response.respuesta == true) {
                    $("#Frm_Recordar")[0].reset();
                    $("#BT_Recordar_Pass").text("Verificar");
                    $("#BT_Recordar_Pass").attr("disabled", "false");
                    app.alertas.success(response.mensaje, "#alertasImportantes")                            
                } else {
                    $("#BT_Recordar_Pass").text("Verificar");
                    $("#BT_Recordar_Pass").attr("disabled", "false");
                    app.alertas.warning(response.mensaje, "#alertasImportantes")
                }
            },
            error: function() {
                app.alertas.error(ERROR_GENERAL_MENSAJE, "#alertasImportantes");
            }
        });
    });
});